/**
 * 参数处理
 * @param {*} params  参数
 */
export const tansParams = (params) => {
  let result = '';
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + '=';
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + '=';
            result += subPart + encodeURIComponent(value[key]) + '&';
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&';
      }
    }
  }
  return result;
};

/**
 * 添加日期范围
 * @param params
 * @param dateRange
 * @param propName
 */
export const addDateRange = (params, dateRange, propName) => {
  const search = params;
  search.params = typeof search.params === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof propName === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
};

// 获取当前时间并向前推算day天
export const getDateOneWeekAgo = (day) => {
  const now = new Date(); // 当前时间
  const oneWeekAgo = new Date(now.getTime() - day * 24 * 60 * 60 * 1000); // 当前时间戳减去day天的毫秒数
  return formatDate(oneWeekAgo);
};
/**
 * 将Date对象格式化为YYYY-MM-DD字符串
 * @param {Date} date - 需要格式化的日期对象
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};
/**
 * 将Date对象格式化为YYYY-MM-DD HH:mm:ss字符串
 * @param {Date} date - 需要格式化的日期对象
 * @returns {string} 格式化后的日期字符串
 */
export const formatDateTime = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export const handleTree = (data, id, parentId, children) => {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  const childrenListMap = {};
  const nodeIds = {};
  const tree = [];

  for (const d of data) {
    const parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (const d of data) {
    const parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }
  const adaptToChildrenList = (o) => {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  };

  for (const t of tree) {
    adaptToChildrenList(t);
  }

  return tree;
};

// 转换字符串，undefined,null等转化为""
export const parseStrEmpty = (str) => {
  if (!str || str == 'undefined' || str == 'null') {
    return '';
  }
  return str;
};

// 验证是否为blob格式
export const blobValidate = (data) => {
  return data.type !== 'application/json';
};

// 日期字符串比较大小
export const compareDates = (date1, date2) => {
  return new Date(date1).getTime() > new Date(date2).getTime();
};
// 判断是否超过几天 超过返回true
export const isWithinOneMonth = (date1, date2, day) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = diffTime / (1000 * 3600 * 24); // 毫秒转换为天
    const diffMonths = diffDays / day;
    return diffMonths > 1;
};
// export const getDayOfWeek = (dateString) => {
//   // 创建一个Date对象
//     const date = new Date(dateString);
//   const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
//   return days[date.getDay()];
// }
// 指定日期是当月的第几周
export const getWeekOfMonth = (date = new Date()) => {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const dayOfWeek = firstDayOfMonth.getDay() || 7; // JavaScript中的getDay()返回0（周日）到6（周六），这里确保周日也是7以便统一计算
    const dayOfMonth = date.getDate();
    const weekOfMonth = Math.ceil((dayOfMonth + dayOfWeek - 1) / 7);
    return weekOfMonth;
}

/**
 * 自定义日期格式化
 * @param {Date|string} date - 日期对象或日期字符串
 * @param {string} format - 格式字符串，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的日期字符串
 */
export const formatDateTimeCustom = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!date) return '';
    
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return '';
    
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    
    return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day)
        .replace('HH', hours)
        .replace('mm', minutes)
        .replace('ss', seconds);
}
